import { render } from "./transaksi-bulanan-id-toko.vue?vue&type=template&id=fcbbc944"
import script from "./transaksi-bulanan-id-toko.vue?vue&type=script&lang=js"
export * from "./transaksi-bulanan-id-toko.vue?vue&type=script&lang=js"
script.render = render

export default script